require('./creditModifyAssociatedAccountStep2.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const { CREDIT_CARD_MODIFY_ASSOCIATED_ACCOUNT } = require('constants/operationTypes'); // @hardcoded
const { CUENTA_CARGO_CANAL } = require('constants/contactCenter/modifyCardAccount');

class CreditModifyAssociatedAccountStep2 extends React.Component {
    constructor(props){
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immCard, immAccounts,newAccountId, isShowOnly } = this.props;
        if(!!newAccountId) {
            const immAccount = immAccounts.get(newAccountId);
            var destinationAccount = immAccount.get('iban');
        }
        const originAccount =  immCard.get('fullContractNumber').replace(/ /g,'');
        const pan = immCard.get('number').replace(/ /g,'');
        const channel = CUENTA_CARGO_CANAL;
        const operationParams = {
             originAccount,
             destinationAccount,
             pan,
             channel
         }
        return (
            <VerifyOtpStep
                operationType={CREDIT_CARD_MODIFY_ASSOCIATED_ACCOUNT}
                operationParams={operationParams}
                isShowOnly={isShowOnly}
            />
        );
    }
}

CreditModifyAssociatedAccountStep2.propTypes = {
    immCard: PropTypes.object,
    immAccounts: PropTypes.object,
    newAccountId: PropTypes.string,
    isShowOnly: PropTypes.bool
};

module.exports = CreditModifyAssociatedAccountStep2;
